import { render, staticRenderFns } from "./DepartmentsList.vue?vue&type=template&id=8f9a7412&scoped=true&"
import script from "./DepartmentsList.vue?vue&type=script&lang=js&"
export * from "./DepartmentsList.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentsList.vue?vue&type=style&index=0&id=8f9a7412&lang=scss&scoped=true&"
import style1 from "./DepartmentsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f9a7412",
  null
  
)

export default component.exports